// The density grid is the one expensive step of an update. It runs in the worker, keyed
// on everything it depends on, so editing a set window never recomputes it, and the old
// grid stays on screen until the new one cross-fades in. GPL-3.0-or-later.
import * as J from "../../lib/jobs.js";
import { densityArgs, computeDensity, type DensityResult } from "../../state/derived.js";
import { X, P, draw, onRecompute } from "./ctx.js";
import { invalidateRaster } from "./net.js";

let key = "", stamp = 0;
const listeners: (() => void)[] = [];
/** Called when a new grid has arrived. */
export const onDensity = (f: () => void) => listeners.push(f);

function planesSig() {
  let h = P().data.planes.length * 31;
  for (const q of P().data.planes) h = (h * 1.000001 + q.dip * 7.1 + q.dipDir * 13.3 + q.quantity * 97) % 1e12;
  return h.toFixed(3);
}
function request() {
  const p = P();
  if (!p.data.planes.length) { X.grid = null; X.levels = []; key = ""; invalidateRaster(); return; }
  const s = p.stereo, d = p.data;
  const k = [planesSig(), s.projection.method, s.projection.hemisphere, s.density.method, s.density.countCircle, s.density.coneRule,
    d.terzaghi.use, d.terzaghi.minBiasDeg, d.traverses.map((t) => JSON.stringify(t.tr)).join(";"), d.planes.map((q) => q.traverse ?? "").join(",")].join("|");
  if (k === key && X.grid) return;
  key = k; const mine = ++stamp;
  const args = densityArgs(p, X.d);
  J.run<DensityResult>("density", args, () => computeDensity(args)).then((r) => {
    if (mine !== stamp || X.signal.aborted) return;  // superseded by a newer request, or unmounted
    X.grid = r.grid; X.levels = r.levels; invalidateRaster();
    performance.mark("dfsuite:density");
    listeners.forEach((f) => f()); draw();
  });
}
export function mountDensity() {
  key = ""; stamp++; listeners.length = 0;
  onRecompute(request);
}
